// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

export const ArrowDown = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 48 48'
      width={size}
      height={size}
      fill={fill || 'none'}
      stroke={stroke}
      strokeWidth='3px'
    >
      <polygon
        xmlns='http://www.w3.org/2000/svg'
        points='46.2 13.2 23.8 35.5 1.5 13.2 2.2 12.5 23.8 34.1 45.5 12.5 46.2 13.2'
      />
    </svg>
  );
};
